<template>
    <div class="col-12 col-md-4 mb-3 card-wrap">
        <div class="card h-100 card-news">
            <div v-if="featured_img" class="aspect-ratio-box aspect-ratio-box-16x9 mb-2">
                <img class="aspect-ratio-box-inner object-fit-contain object-position-center-center" :src="featured_img" :aria-label="alt_text"/>
            </div>
            <div class="card-body px-0 pt-0">
                <span v-if="type" class="btn btn-dark">{{ type }}</span>
                <span class="ml-1">{{ publish_date }}</span>
                <h6 class="card-title pt-2 mb-0" v-html="title"></h6>
                <div class="card-text py-2">{{ excerpt }}</div>
                <div class="card-link mt-2">
                    <a class="btn btn-primary px-3" :href="permalink">Read Full Article</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['news'],
        data() {
            return {
                title: '',
                excerpt: '',
                featured_img: '',
                alt_text: '',
                publish_date: '',
            }
        },

        methods: {
            renderPost(){

                this.title = this.$props.news['title']
                this.featured_img = this.$props.news['featured_img']
                this.alt_text = this.$props.news['img_alt']
                this.publish_date = this.$props.news['publish_date']
                this.excerpt = this.$props.news['excerpt']
                this.type = this.$props.news['type']
                this.permalink = this.$props.news['permalink']

            }
        },
        mounted(){
            this.renderPost()
        }
    }
</script>
